// extracted by mini-css-extract-plugin
module.exports = {"link":"deda3__index-module__link"};